exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-title-container[data-v-78109012]{align-items:center;display:flex;width:100%}.k-title-text[data-v-78109012]{flex-grow:1;overflow:hidden;padding:8px 10px;text-overflow:ellipsis;white-space:nowrap;color:var(--sb-table-header-text, #94a3b8);font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.04em}.k-title-text.k-title-sortable[data-v-78109012]{cursor:pointer;user-select:none}.k-title-text.k-title-sortable[data-v-78109012]:hover{color:var(--sb-table-body-text, #1e293b)}.k-sort-order[data-v-78109012]{font-size:10px !important;height:0px !important}\n", ""]);

// exports
